import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_config_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  config_type: fromDatatype.VarcharDatatypeInterface;
  config_field: fromDatatype.VarcharDatatypeInterface;
  sequence_num: fromDatatype.NumericDatatypeInterface;
  prefix_code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.JsonDatatypeInterface;
  updated_date: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}

export class bl_crm_membership_config_RowClass
  implements bl_crm_membership_config_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  config_type: fromDatatype.VarcharDatatypeInterface;
  config_field: fromDatatype.VarcharDatatypeInterface;
  sequence_num: fromDatatype.NumericDatatypeInterface;
  prefix_code: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.JsonDatatypeInterface;
  updated_date: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
}
